/* eslint-disable no-unused-vars */
import { RootActionTypes, RootMutationTypes } from './types';

export const actions = {
    async [RootActionTypes.SetHost]({ commit }) {
        const host = window.location.origin        
        let origin = ''
        if (host.includes('localhost')) {
            origin = 'RU'
        } else {
            origin = host.split('.')[1].toUpperCase();
        }
        commit(RootMutationTypes.SetHost, { host })
        commit(RootMutationTypes.SetOrigin, { origin })
    },
}